
import {
    Coast,
    District,
    Entity,
    Island,
    Municipality,
    Neighbourhood,
    Province,
    Region,
} from '../../locations';

const onMapMove = ( ctx, event ) => {
    let isBoxAnimation = !!event.boxAnimation;

    if ( isBoxAnimation || !( 'originalEvent' in event ) ) {
        return;
    }

    if ( !ctx.currentLocation || !ctx.movefuncs ) {
        return;
    }

    let layers = [
        Region,
        Province,
        Coast,
        Island,
        Municipality,
        District,
        Neighbourhood,
        Entity,
    ];

    layers = layers.map( ( name ) => {
        return name + ':fill';
    } );

    layers = layers.filter( ( name ) => {
        return !!ctx.map.getLayer( name );
    } );

    const visibleFeatures = ctx.map.queryRenderedFeatures( {
        layers: layers,
        validate: ctx.debug,
    } );

    for ( let i = 0; i < visibleFeatures.length; i++ ) {
        for ( let f = 0; f < ctx.movefuncs.length; f++ ) {
            const func = ctx.movefuncs[ f ];
            const feature = visibleFeatures[ i ];
            func( ctx, feature );
        }
    }
};

export default onMapMove;
